const state = {
    is_valid: false,
    media: null,
    event: null,
}

export const getters = {
    is_valid: state => state.is_valid,
    media: state => state.media,
    event: state => state.event,
}


export const mutations = {
    set_is_valid(state, is_valid) {
        state.is_valid = is_valid
    },
    set_media(state, media) {
        state.media = media
    },
    set_event(state, event) {
        state.event = event
    }
}


export const actions = (sharedService) => ({
    async getMediaUrl({commit}, {hash, user_id, media_id}) {
        const data = await sharedService.getMediaUrl({hash, user_id, media_id})
        commit('set_is_valid', data.is_valid)
        commit('set_media', data.media)
        commit('set_event', data.event)
        return data.is_valid
    }
})

export default sharedService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(sharedService)
})
